import { EEstimationTargets, ESuburbanEstimationCategory } from '@cian/valuation-main-filters-widget';
import { ECategory } from '../repositories/price-estimator/entities/estimation_suburban/EstimationSuburbanRequestSchema';

export const mapEstimationTargetToCategory: { [key: string]: ESuburbanEstimationCategory } = {
  [EEstimationTargets.house]: ESuburbanEstimationCategory.HouseSale,
  [EEstimationTargets.land]: ESuburbanEstimationCategory.LandSale,
};

export const mapEstimationTargetToECategory: { [key: string]: ECategory } = {
  [EEstimationTargets.house]: ECategory.HouseSale,
  [EEstimationTargets.land]: ECategory.LandSale,
};
